module.exports = __webpack_public_path__ + "img/illu-stomach.036c40bc.svg";